import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import _ from 'lodash';
import { dp, presetDp } from '../../../utils/shared.js';
import ReactIScroll from 'react-iscroll';
import iScroll from 'iscroll';
import InfoBlockSeattle from './InfoBlockSeattle'
import StorySeattle from './StorySeattle';
import LazyLoad from 'react-lazyload';
import {forceCheck} from 'react-lazyload';

class TimelineSeattle extends Component {
  constructor(props) {
    super(props);
    this.refDict = []
    this.timelineRefs = []
    this._events = [];
    this._contentRef = null;
    this._events_on_screen = 20;
    this._screenWidth = this.props.regionWidth;
    this._centerline = this._screenWidth * .17
    let eventInc = (this.props.regionHeight / this._events_on_screen) * 2;

    let items = this.props.items;

    items = items.sort(function compare(a, b) {
      let adate = new Date(_.get(a, 'contents.sorting_date', '2000-01-01'))
      let bdate = new Date(_.get(b, 'contents.sorting_date', '2000-01-01'))
      return adate - bdate
    });

    _.forEach(items, (event, index) => {
      let raw = eventInc * index;
      let span = raw + eventInc;
      let strDate = _.get(event, 'contents.sorting_date', '2000-01-01');
      let rawDate = new Date(strDate.split('-')[0], Number(strDate.split('-')[1]) - 1, strDate.split('-')[2], 0, 0, 0);
      this._events.push({ header: event.header, rawDate: rawDate, date: this.parseDate(rawDate), offset: span, raw: raw, text: _.get(event, 'contents.text0', ''), images: _.get(event, 'contents.images', []), story: event })
    });

    this._totalHeight = (this._events.length + 2) * (this.props.regionHeight / this._events_on_screen * 2);
    this.state = {
      showStory: false,
      hideTimeline: false,
      initializedRefs: false,
      story: null
    }
  }

  componentDidMount() {
    this.intervalCheckSwipeAnimation();
  }

  componentWillUnmount() {
    for (let a = 0; a < this.timelineRefs.length; a++) {
      if (this.timelineRefs[a].el) {
        this.timelineRefs[a].el.removeEventListener("tap", () => this.handleEventSelection(this.timelineRefs[a].data));
      }
    }
  }

  intervalCheckSwipeAnimation = () => {
    if (!this._contentRef) {
      setTimeout(() => {
        this.intervalCheckSwipeAnimation();
      }, 100);
    } else {
      this.checkSwipeAnimation();
    }
  }
  
  checkSwipeAnimation = () => {
    let scrollWrapperHeight = 0.438 * this.props.regionWidth;
    this.props.handleSwipeAnimation(scrollWrapperHeight, this._totalHeight);
  }  

  randomDiv() {
    let r = Math.random().toString(36).substring(7);

    return (
      <div>{r}</div>
    )
  }

  parseDate = (date) => {
    // let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    //   "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    // ];
    // let monthName = monthNames[date.getMonth()]
    // let monthNumber = String(date.getMonth() + 1);
    let fullYear = String(date.getFullYear());
    // let shortYear = fullYear.substring(2);
    // let day = String(date.getDate());
    // let unit = this.props.screen.r9_16.p10
    return <span>
      <b>
        {/* <span style={{ fontSize: '2vh' }}>{monthName} {day}</span>
                <br /> */}
        <span style={{ overflow: 'visible', fontSize: 0.0225 * this.props.regionWidth }}>{fullYear}</span>
      </b>
    </span>


  }

  // setupBackButtonRef = () => {
  //     console.log("setting up nack ref");
  //     console.log(this._backButtonRef);
  //     if (this._backButtonRef) {
  //       this._backButtonRef.addEventListener('click', () => this.handleBackButtonClick());
  //     } else {
  //       setTimeout(() => {
  //         this.setupBackButtonRef();
  //       }, 100)
  //     }
  //   }

  handleBackButtonClick = () => {
    this.setState({
      showStory: false,
      story: null,
      hideTimeline: false
    });
    // setTimeout(() => {
    //   this.setState({
    //     hideTimeline: false
    //   });
    //   this.setupRefs();
    // }, 450)
  }


  renderSpacialEvents() {
    // timeline circle
    const unit = this.props.regionWidth * 0.3;
    let circleRadius = unit * 0.15

    if (this._events.length === 0) {
      return (
        <span />
      )
    }

    const infoBlockWidth = unit * 3.35 * .1;
    const imageHeight = unit * 2 * .1;
    const infoHeight = unit * .85 * .1;

    // const insetAmount = unit * 1.55
    // const leftInset = -insetAmount - infoBlockWidth;
    // const rightInset = insetAmount;

    // const fullHeight = imageHeight + infoHeight
    // const iconWidth = unit * .25;
    const h_width = unit * .15
    
    return (
      this._events.map(function (row, i) {
        let thumbImage = presetDp('thumbnail', _.get(row, 'images[0]', null), this.props.screen);

        //assume right
        let h_inset = this._centerline

        let c_inset = this._centerline + h_width - (circleRadius / 2)
        let t_inset = c_inset + this._screenWidth * .07
        let floatRight = false;

        //offset for left scenario
        if (i % 2 === 0) {
          floatRight = true;
          h_inset = this._centerline - h_width
          // c_inset = this._centerline - h_width - this._screenWidth * .05
          c_inset = 0;
          // t_inset = c_inset - this._screenWidth * .07
          t_inset = this.props.regionWidth * .01736;
        }

        return (
          <div key={i} style={{ position: 'absolute', top: row.offset, zIndex: 0 }}>
            {/* horizontal lines */}
            <div style={{
              position: 'absolute',
              backgroundColor: 'white',
              top: 0,
              left: h_inset,
              width: h_width,
              height: 0.0039 * this.props.regionWidth,
              zIndex: 0
            }}>
            </div>
            <span className="noselect" ref={el => this.timelineRefs[i] = { el: el, data: row }} style={{ width: .14322 * this.props.regionWidth, top: -0.025 * this.props.regionWidth, position: 'absolute', left: c_inset, zIndex: 9999 }}>
              <LazyLoad once={true} offset={this.props.regionWidth * 0.5}>
                <InfoBlockSeattle
                  imgsrc={thumbImage}
                  imageHeight={imageHeight}
                  infoHeight={infoHeight}
                  width={infoBlockWidth}
                  unit={unit * .8}
                  text={row.header}
                  infoColor={"black"}
                  infoBackgroundColor={'white'}
                  fontFamily={'opensans-regular'}
                  fontSize={unit * 0.15}
                  floatRight={floatRight}
                />
              </LazyLoad>
            </span>
            <span className="noselect" style={{ overflow: 'visible', fontSize: 5, top: -(0.0012 * this.props.regionWidth), position: 'absolute', left: t_inset, zIndex: 1 }}>
              {row.date}
            </span>
          </div>
        )
      }, this)
    )
  }

  initializeTimelineRefs = () => {
    if (this.state.initializedRefs === false) {
      for (let a = 0; a < this.timelineRefs.length; a++) {
        this.timelineRefs[a].el.addEventListener("tap", () => this.handleEventSelection(this.timelineRefs[a].data));
      }
      this.setState({
        initializedRefs: true
      })
    }
  }

  handleEventSelection = (data) => {
    this.setState({
      hideTimeline: true,
      showStory: true,
      story: data.story
    })
  }

  onScrollStart = () => {
    forceCheck();
  }

  onScrollEnd = () => {
    forceCheck();
  }

  render() {
    let events = this.renderSpacialEvents()
    const backButton = dp(this.props.screen, null, { path: '/img/seattle/general/', file_name: 'back.png' });

    let containerClass = "gradiant fadediv"
    if (this.state.hideTimeline === true) {
      containerClass += " fadeout"
    }

    return (
      <div>
        <div className={containerClass} style={{ position: "absolute", top: .035 * this.props.regionWidth, left: .039 * this.props.regionWidth, height: 0.438 * this.props.regionWidth, width: "100%", touchAction: "none" }}>
          <ReactIScroll ref={el => this.refDict[0] = el} iScroll={iScroll}
            options={{
              mouseWheel: true,
              scrollbars: false,
              scrollX: false,
              scrollY: true,
              probeType: 2,
              bounce: false,
              momentum: true,
              deceleration: 0.015,
              useTransition: true,
              disableTouch: false,
              disablePointer: false,
              disableMouse: false,
              tap: true
            }}
            onRefresh={this.initializeTimelineRefs}
            onScrollStart={this.onScrollStart}
            onScrollEnd={this.onScrollEnd}
          >

            {/* TIMELINE DIV */}
            <div style={{ width: 0.303 * this.props.regionWidth, height: this._totalHeight, minHeight: '100%' }}>
              {/* vertical line */}
              <div style={{
                position: 'absolute',
                top: 0,
                backgroundColor: 'white',
                left: this._centerline,
                width: 0.0039 * this.props.regionWidth,
                height: '100%'
              }} />
              <div style={{
                position: 'absolute',
                width: 0.3712 * this.props.regionWidth,
                height: 0.5625 * this.props.regionWidth
              }}>
                {/* <span style={this._titleHorizontalRule} /> */}
              </div>
              {events}
            </div>
          </ReactIScroll>
        </div>
        <CSSTransitionGroup
          component='div'
          className="fastfadedelay"
          style={{ minHeight: '100%' }}
          transitionName='example'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={this.state.showStory}>
            {
              this.state.showStory ?
                <div style={{ position: "absolute", left: 0, width: "100%", height: "100%" }}>
                  <div>
                    <StorySeattle
                      item={this.state.story}
                      screen={this.props.screen}
                      regionWidth={this.props.regionWidth}
                      handleSwipeAnimation={this.props.handleSwipeAnimation}
                      cancelSwipeAnimation={this.props.cancelSwipeAnimation}
                    />
                  </div>
                </div>
                : null
            }
          </div>
        </CSSTransitionGroup>
        <CSSTransitionGroup
          component='div'
          className="fastfadedelay"
          style={{ minHeight: '100%' }}
          transitionName='example'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          {
            this.state.showStory ?
              <div key={this.state.showStory} onClick={() => this.handleBackButtonClick()}>
                <img src={backButton} style={{ position:"absolute", left: 0, bottom: .02777777777777777778
 * this.props.regionWidth, width:0.050 * this.props.regionWidth }} alt="" />
              </div>
              : null
          }
        </CSSTransitionGroup>
      </div>
    )
  }
}

export default TimelineSeattle


// WEBPACK FOOTER //
// ./src/Components/Theme/Seattle/TimelineSeattle.jsx